import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class SEp2 extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Special Ep 5: Korean age vs. International age, K-beauty — Q and A!</h1>
                        <h5 className="korean-title">특별 에피소드 5: 질문/답</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">

나이 (nah eeh) — age <br></br>
나이를 세다 (nah eeh reul sae da) — to count age <br></br>
방법 (bang bup) — method, way <br></br>
태어나다 (tae uh na da) — to be born <br></br>

 <br></br>
만나이 (man na eeh) — international age <br></br>
만으로 23살입니다 (man euh ro 23sal ip ni da) — 23 years old in international age <br></br>

<br></br>
Pictures from Seoul Fashion Week Vogue are <a target="_blank" href="https://www.vogue.com/slideshow/seoul-fashion-week-fall-2021-best-street-style">here</a>!<br></br>
Some other cool pictures of Korean fashion: <br></br>
<img className="epPic-m" src="https://cdn.cliqueinc.com/posts/280710/korean-fashion-trends-280710-1561004501829-main.700x0c.jpg"></img><br></br>
<img className="epPic-m" src="https://3.bp.blogspot.com/-rDKGUSuB51k/XKskUUt7ZBI/AAAAAAAAJRM/K0f-4G7uB2Mp5lWaTeg0bvtYJjgHhNo0QCLcBGAs/s1600/korean%2Bfashion%2Bbasic.jpg"></img><br></br>
<img className="epPic-m" src="https://media.allure.com/photos/58ce990043bdf2247e9b920a/16:9/w_2560%2Cc_limit/GettyImages-615852030.jpg"></img><br></br>
<img className="epPic-m" src="https://discovery.cathaypacific.com/wp-content/uploads/2018/08/korean-Fashion-8.jpg"></img><br></br>
<img className="epPic-m" src="https://cdn.ceoworld.biz/wp-content/uploads/2020/11/SOUTH-KOREA-SEOUL-FASHION.jpg"></img><br></br>


<br></br>
영어 할 줄 아세요? (younguh hal jul ahsaeyo) — Do you know English? <br></br>
안녕하세요 (annyeonghasaeyo) — Hello <br></br>
화장실은 어디 있나요? (hwajang sileun uhdi itnayo)  — Where is the bathroom? <br></br>
이거 얼마에요? (eehguh ulmaeyo) — How much is this? <br></br>
Are basic phrases to know in Korea are <a target="_blank" href="https://www.fluentu.com/blog/korean/korean-travel-phrases/">here</a>!<br></br>

 <br></br>
허황옥 (huh hwang ok) — queen of the kingdom gaya, who apparently came from Ayodhya



                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <SEp2></SEp2>
        </div>
    );
}


  const Sepisode2 = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Sepisode2;